import { Component } from '@angular/core';
import { BannerService, BannerData } from './services/banner.service';
import { Observable } from 'rxjs';
import { SwalService } from './services/utls/swal.service';
import { ThemeService } from './services/theme/theme.service';
// TranslationService eliminado - usando OptimizedI18nService
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  bannerData$: Observable<BannerData | null>;
  title = 'web';
  bannerMessage: string = '';
  bannerVisible: boolean = false;
  constructor(
    private bannerService: BannerService,
    public swalService: SwalService,
    private themeService: ThemeService,
    // private translationService: TranslationService - eliminado
  ) {
    this.bannerData$ = this.bannerService.bannerData$;
  }

  ngOnInit() {
    // Inicializar idioma por defecto
    const savedLang = localStorage.getItem('selectedLanguage') || 'es';
    document.documentElement.lang = savedLang;
    
    // Inicializar tema por defecto
    this.themeService.initializeTheme();
    
    // Forzar aplicación del tema por defecto si no hay tema guardado
    setTimeout(() => {
      const savedTheme = localStorage.getItem('selectedTheme');
      if (!savedTheme) {
        this.themeService.setTheme('moderno');
      }
    }, 100);
    
    // this.initGeolocation();
    if (this.isMobileDevice()) {
      this.mobileApp();
    }
  }

  private isMobileDevice(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  private initGeolocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            //timestamp: new Date().getTime()
          };

          // Almacenar en localStorage
          localStorage.setItem('userLocation', JSON.stringify(coords));

          //console.log('Ubicación almacenada:', coords);
        },
        (error) => {
          console.error('Error obteniendo ubicación:', error);
          this.handleGeolocationError(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }
      );
    } else {
      console.warn('Geolocalización no soportada por el navegador');
    }
  }

  private handleGeolocationError(error: GeolocationPositionError) {
    const errorMessages = {
      1: 'Permiso denegado por el usuario',
      2: 'Posición no disponible',
      3: 'Tiempo de espera agotado'
    };

    const defaultCoords = {
      lat: 4.712164, // Valores por defecto (Ej: Mérida, Venezuela)
      lng: -74.078913,
      //timestamp: new Date().getTime(),
      //isDefault: true
    };

    console.warn(errorMessages[error.code] || 'Error desconocido');

    // Almacenar ubicación por defecto
    localStorage.setItem('userLocation', JSON.stringify(defaultCoords));
  }

  private isIOS(): boolean {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  async mobileApp(): Promise<void> {
    const result = await this.swalService.verify(
      'Informativo',
      'Para mayor comodidad, te recomendamos descargar nuestra aplicación móvil.',
      'Descargar'
    );

    if (result.isConfirmed) {
      this.redirectToAppStore();
    }
  }

  private redirectToAppStore(): void {
    if (this.isIOS()) {
      // Redirigir a App Store de iOS
      window.location.href = 'https://apps.apple.com/co/app/plataforma/id6741082878';
    } else {
      // Redirigir a Google Play Store
      window.location.href = 'https://play.google.com/store/apps/details?id=com.plataformaApp.plataformaApp';
    }
  }
}
